/* unplugin-vue-components disabled */import script from "./indexProjectShow.vue?vue&type=script&setup=true&lang=js"
export * from "./indexProjectShow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__